<script setup lang="ts">
</script>

<template>
    <v-chip
        variant="tonal"
        color="surface-light"
        density="compact"
        size="sm"
        theme="customDarkTheme"
        class="text-caption font-weight-bold text-medium-emphasis px-2"
    >
        <div class="text-grey-darken-1">
            <slot />
        </div>
    </v-chip>
</template>

<style scoped>

</style>
